// extracted by mini-css-extract-plugin
var _1 = "eVM_dgVs";
var _2 = "lcULLFED";
var _3 = "lcULLFED";
var _4 = "IxyurbKe";
var _5 = "IxyurbKe";
var _6 = "TszBa7Dl";
var _7 = "TszBa7Dl";
var _8 = "YIR4eD4S";
var _9 = "dDnT0pW8";
var _a = "uAKhCNWo";
var _b = "ZZr8cDyt";
var _c = "uAKhCNWo";
var _d = "ZZr8cDyt";
var _e = "nPLios5k";
var _f = "nPLios5k";
export { _1 as "block", _2 as "characteristics-popover", _3 as "characteristicsPopover", _4 as "content-item", _5 as "contentItem", _6 as "is-good-for", _7 as "isGoodFor", _8 as "label", _9 as "properties", _a as "properties-item", _b as "properties-list", _c as "propertiesItem", _d as "propertiesList", _e as "wine-info", _f as "wineInfo" }
